/* ==========================================================================
   Executive Beverage — Crush Kit builder
   --------------------------------------------------------------------------
   Self-service drop-off package. Distinct from the full estimate builder: no
   bars, no staff, no hours of service — just a guest count, how long you are
   pouring, and how hard the party goes.

   Two totals, kept deliberately separate:
     - What Executive Beverage charges (kit + delivery + optional tip)
     - What the client will spend on spirits, which they buy themselves
   Blending those would misrepresent both numbers.

   No dependencies. Progressive enhancement: the form works without this file,
   it just will not show a live recommendation.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-eb-crush]');
  if (!root) return;

  var num = function (sel) {
    var el = root.querySelector(sel);
    if (!el) return 0;
    return parseFloat(String(el.value).replace(/[^0-9.]/g, '')) || 0;
  };
  var attr = function (name, fallback) {
    var v = parseFloat(root.getAttribute(name));
    return isFinite(v) ? v : fallback;
  };
  var money = function (n) {
    return '$' + (Math.round(n * 100) / 100).toLocaleString('en-US', {
      minimumFractionDigits: n % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  };

  var out = {
    crushes: root.querySelector('[data-eb-crush-count]'),
    juicedLine: root.querySelector('[data-eb-crush-juiced-line]'),
    juicedAmt: root.querySelector('[data-eb-crush-juiced-amt]'),
    bottles: root.querySelector('[data-eb-crush-bottles]'),
    kit: root.querySelector('[data-eb-crush-kit]'),
    delivery: root.querySelector('[data-eb-crush-delivery]'),
    tip: root.querySelector('[data-eb-crush-tip]'),
    total: root.querySelector('[data-eb-crush-total]'),
    alcohol: root.querySelector('[data-eb-crush-alcohol]'),
    allin: root.querySelector('[data-eb-crush-allin]'),
    note: root.querySelector('[data-eb-crush-note]'),
    rate: root.querySelector('[data-eb-crush-rate]'),
    rateNote: root.querySelector('[data-eb-crush-rate-note]'),
    travelLine: root.querySelector('[data-eb-crush-travel-line]'),
    travelAmt: root.querySelector('[data-eb-crush-travel]'),
    travelDetail: root.querySelector('[data-eb-crush-travel-detail]')
  };

  function recalc() {
    var guests = num('[data-eb-crush-guests]');
    var hours = num('[data-eb-crush-hours]') || 1;
    var minHeads = attr('data-eb-min-heads', 10);
    /* Two rates. A kit that rides along with a staffed job costs less to get
       there, so it is cheaper — and showing the cheaper number next to the
       checkbox is what makes anyone tick it. */
    var bundled = !!(root.querySelector('[data-eb-crush-bundled]') || {}).checked;
    var perCrush = bundled
      ? attr('data-eb-price-crush-bundled', 3.25)
      : attr('data-eb-price-crush', 4);
    var bottlePrice = attr('data-eb-bottle-price', 25.99);
    var perBottle = attr('data-eb-crushes-per-bottle', 11);
    var freeAt = attr('data-eb-free-delivery-at', 15);
    var rushFee = attr('data-eb-rush-fee', 100);
    var deliveryFee = attr('data-eb-delivery-fee', 0);

    // Party level sets crushes per guest per hour.
    var levelEl = root.querySelector('[data-eb-crush-level]:checked');
    var rate = levelEl ? parseFloat(levelEl.getAttribute('data-eb-rate')) || 1.5 : 1.5;

    /* Travel now comes from the shared component, same as the estimate builder
       and the cocktail class: city for a baseline, ZIP to sharpen it, and only
       the miles OVER the radius charged, both directions. This used to ask for a
       raw mileage figure, which nobody knows off the top of their head and which
       disagreed with the dropdown the estimate already had. */
    var travelCost = 0;
    var miles = NaN;
    var freeMiles = attr('data-eb-travel-free-miles', 20);
    var perMile = attr('data-eb-travel-rate', 2);
    if (window.EBTravel) {
      var d = window.EBTravel.resolve(root);
      var c = window.EBTravel.cost(root, d.miles);
      window.EBTravel.paint(root);
      miles = d.miles;
      travelCost = c.amount;
      freeMiles = c.freeMiles;
      perMile = c.rate;
    }

    var rush = !!(root.querySelector('[data-eb-crush-rush]') || {}).checked;
    var juiced = !!(root.querySelector('[data-eb-crush-juiced]') || {}).checked;
    var juicedRate = attr('data-eb-price-juiced', 2);
    var tipPctEl = root.querySelector('[data-eb-crush-tip-pct]');
    var tipCustomEl = root.querySelector('[data-eb-crush-tip-custom]');
    var tipCustomWrap = root.querySelector('[data-eb-crush-tip-custom-wrap]');
    /* Same rule as the estimate builder: the custom box only counts while it is
       on screen, so a number left in a hidden field cannot keep charging. */
    var tipCustom = !!(tipPctEl && tipPctEl.value === 'custom');
    if (tipCustomWrap) tipCustomWrap.hidden = !tipCustom;
    var tipPct = 0;
    if (tipCustom) {
      var raw = parseFloat(String(tipCustomEl && tipCustomEl.value).replace(/[^0-9.]/g, ''));
      tipPct = isFinite(raw) && raw > 0 ? Math.min(raw, 100) : 0;
    } else if (tipPctEl) {
      tipPct = parseFloat(tipPctEl.value) || 0;
    }

    /* The below-minimum warning is no longer written here. eb-limits.js owns
       it: it renders the message against the guest field itself and blocks the
       submit, which this never did. Two copies of the same sentence, one of
       them nowhere near the input, was the result of keeping both. */

    var crushes = Math.ceil(guests * rate * hours);
    var bottles = crushes > 0 ? Math.ceil(crushes / perBottle) : 0;
    var kitCost = crushes * perCrush;
    var delivery = guests >= freeAt ? 0 : deliveryFee;
    var rushCost = rush ? rushFee : 0;
    var juicedCost = juiced ? crushes * juicedRate : 0;
    /* Travel sits outside the tip base. The tip is for the people who pack,
       drive and return the kit; tipping a percentage of mileage is not what
       anyone means by it. */
    var tip = (kitCost + juicedCost + delivery + rushCost) * (tipPct / 100);
    var ebTotal = kitCost + juicedCost + delivery + rushCost + travelCost + tip;
    var alcohol = bottles * bottlePrice;

    if (out.rate) out.rate.textContent = money(perCrush);
    if (out.rateNote) {
      out.rateNote.textContent = bundled
        ? ' bundled rate'
        : ' \u00d7 ' + crushes.toLocaleString('en-US');
    }
    if (out.crushes) out.crushes.textContent = crushes.toLocaleString('en-US');
    if (out.bottles) out.bottles.textContent = bottles.toLocaleString('en-US');
    if (out.kit) out.kit.textContent = money(kitCost);
    if (out.juicedLine) {
      out.juicedLine.hidden = !juiced;
      if (out.juicedAmt) out.juicedAmt.textContent = money(juicedCost);
    }
    if (out.delivery) {
      out.delivery.textContent = rush
        ? money(delivery + rushCost) + ' (same-day rush)'
        : (delivery === 0 ? 'Free' : money(delivery));
    }
    if (out.travelLine) {
      out.travelLine.hidden = travelCost <= 0;
      if (out.travelAmt) out.travelAmt.textContent = money(travelCost);
      if (out.travelDetail) {
        // Short form only. The sentence lives beside the city and ZIP fields.
        out.travelDetail.textContent = travelCost > 0 ? ' — ' + miles + ' mi' : '';
      }
    }
    if (out.tip) out.tip.textContent = tipPct > 0 ? money(tip) + ' (' + tipPct + '%)' : '—';
    if (out.total) out.total.textContent = money(ebTotal);
    if (out.alcohol) out.alcohol.textContent = money(alcohol);
    if (out.allin && crushes > 0) {
      out.allin.textContent = money((ebTotal + alcohol) / crushes) + ' per crush, all in';
    } else if (out.allin) {
      out.allin.textContent = '';
    }

    if (out.note && crushes > 0) {
      out.note.textContent =
        crushes + ' crushes — ' + rate + ' per guest per hour across ' + hours +
        (hours === 1 ? ' hour' : ' hours') + '. ' + bottles +
        (bottles === 1 ? ' bottle' : ' bottles') + ' of Perfect Crush at ' +
        perBottle + ' crushes each.';
    } else if (out.note) {
      out.note.textContent = '';
    }

    // Mirror the working numbers into hidden fields so the email is readable.
    var spec = root.querySelector('[data-eb-crush-spec]');
    if (spec) {
      spec.value =
        'Guests: ' + guests + '\n' +
        'Pouring for: ' + hours + ' hours\n' +
        'Party level: ' + (levelEl ? levelEl.value : '—') + ' (' + rate + ' crushes/guest/hour)\n' +
        'Recommended crushes: ' + crushes + '\n' +
        'Juiced on site: ' + (juiced ? 'Yes (' + money(juicedCost) + ')' : 'No') + '\n' +
        'Perfect Crush bottles to buy: ' + bottles + ' (approx ' + money(alcohol) + ')\n' +
        'Per crush: ' + money(perCrush) + (bundled ? ' (bundled with other services)' : '') + '\n' +
        'Kit: ' + money(kitCost) + '\n' +
        'Delivery: ' + (delivery === 0 ? 'free' : money(delivery)) +
          (rush ? ' + same-day rush ' + money(rushCost) : '') + '\n' +
        (travelCost > 0
          ? 'Travel: ' + money(travelCost) + ' (' + miles + ' miles; ' +
            (miles - freeMiles) + ' past ' + freeMiles + ', both ways at ' + money(perMile) + '/mi)\n'
          : 'Travel: none, or quoted from the address\n') +
        (tipPct > 0 ? 'Tip: ' + money(tip) + ' (' + tipPct + '%)\n' : '') +
        'Executive Beverage total: ' + money(ebTotal);
    }
  }

  root.addEventListener('input', recalc);
  root.addEventListener('change', recalc);
  recalc();
})();
